import axios from '@/api/config';

const userProject = {
  getUserProjectById(data) {
    return axios.get(`${process.env.BASE_URL}/userProject/getUserProjectById/` + data, {});
  },
  getUserProjectDetail(data) {
    return axios.get(`${process.env.BASE_URL}/userProject/getUserProjectDetail`, {params: data});
  },
  getUserProject(data) {
    return axios.get(`${process.env.BASE_URL}/userProject/getUserProject`, {params: data});
  },
  getUserProjectList(data) {
    return axios.get(`${process.env.BASE_URL}/userProject/getUserProjectList`, {params: data});
  },
  getUserProjectTree(data) {
    return axios.get(`${process.env.BASE_URL}/userProject/getUserProjectTree`, {params: data});
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/userProject/pageList`, data);
  },
  addUserProject(data) {
    return axios.post(`${process.env.BASE_URL}/userProject/addUserProject`, data);
  },
  updateUserProject(data) {
    return axios.put(`${process.env.BASE_URL}/userProject/updateUserProject`, data);
  },
  deleteUserProject(data) {
    return axios.delete(`${process.env.BASE_URL}/userProject/deleteUserProject`,  {data: data});
  },
  exportExcel(data) {
    return axios.get(`${process.env.BASE_URL}/userProject/exportExcel`, {params: data});
  },
  importData(data) {
    return axios.post(`${process.env.BASE_URL}/userProject/importData`, data);
  },
  active(data) {
    return axios.post(`${process.env.BASE_URL}/userProject/active`, data);
  },
}

export default userProject;



// WEBPACK FOOTER //
// ./src/api/userProject.js